module.exports = __webpack_public_path__ + "static/media/success.82ee179c.png";